import { PhotoCapture } from '../enums';
export const INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_INTELLIGENT_IMAGE_CONTENT_DETECTION_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_INTELLIGENT_IMAGE_CONTENT_DETECTION_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_FAILURE = `${PhotoCapture.PHOTO_CAPTURE}_INTELLIGENT_IMAGE_CONTENT_DETECTION_FAILURE`;
export const photoCaptureIntelligentImageContentDetectionRequestAction = (payload) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_REQUEST,
    payload
});
export const photoCaptureIntelligentImageContentDetectionSuccessAction = (imageContentDetectionResponse) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_SUCCESS,
    payload: { imageContentDetectionResponse }
});
export const photoCaptureIntelligentImageContentDetectionFailureAction = failureMessage => ({
    type: INTELLIGENT_PHOTO_CAPTURE_IMAGE_CONTENT_DETECTION_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=photoCaptureIntelligentImageContentDetectionAction.js.map